export default __webpack_public_path__ + "static/media/Chatz2.705e7bbd.png";